// Pricing data derived from the provided price lists.
// Each feature row carries FR/EN labels and inclusion flags per formula tier.

export const autoFormulas = {
  interior: {
    tiers: [
      { id: "refresh", name: "Refresh", price: 110 },
      { id: "optimum", name: "Optimum", price: 250 },
      { id: "platinum", name: "Platinum", price: 390 },
    ],
    rows: [
      { fr: "Lavage intérieur léger", en: "Light interior wash", inc: [true, true, true] },
      { fr: "Nettoyage des plastiques", en: "Plastics cleaning", inc: [true, true, true] },
      { fr: "Nettoyage sièges textile", en: "Textile seats cleaning", inc: [true, true, true] },
      { fr: "Lavage intérieur profond", en: "Deep interior wash", inc: [false, true, true] },
      { fr: "Traitement des taches", en: "Stain treatment", inc: [false, true, true] },
      { fr: "Nettoyage sièges cuir", en: "Leather seats cleaning", inc: [false, true, true] },
      { fr: "Ravivement des plastiques", en: "Plastics revival", inc: [false, true, true] },
      { fr: "Entretien & protection cuir", en: "Leather care & protection", inc: [false, false, true] },
      { fr: "Traitement vapeur", en: "Steam treatment", inc: [false, false, true] },
    ],
  },
  exterior: {
    tiers: [
      { id: "refresh", name: "Refresh", price: 110 },
      { id: "optimum", name: "Optimum", price: 250 },
      { id: "platinum", name: "Platinum", price: 690 },
    ],
    rows: [
      { fr: "Prélavage", en: "Pre-wash", inc: [true, true, true] },
      { fr: "Lavage", en: "Wash", inc: [true, true, true] },
      { fr: "Traitement des insectes", en: "Bug removal", inc: [true, true, true] },
      { fr: "Lavage profond", en: "Deep wash", inc: [false, true, true] },
      { fr: "Décontamination", en: "Decontamination", inc: [false, true, true] },
      { fr: "Wax", en: "Wax", inc: [false, true, true] },
      { fr: "Ravivement plastiques ext.", en: "Exterior plastics revival", inc: [false, true, true] },
      { fr: "Céramique", en: "Ceramic coating", inc: [false, false, true] },
      { fr: "Céramique jantes & vitres", en: "Ceramic on wheels & glass", inc: [false, false, true] },
      { fr: "Traitement vapeur", en: "Steam treatment", inc: [false, false, true] },
    ],
  },
  combo: [
    { id: "refresh", name: "Refresh", withDiscount: 180, withoutDiscount: 220 },
    { id: "optimum", name: "Optimum", withDiscount: 375, withoutDiscount: 500 },
    { id: "platinum", name: "Platinum", withDiscount: 810, withoutDiscount: 1080 },
  ],
};

export const motoFormula = {
  tiers: [
    { id: "entretien", name: "Entretien", price: 120 },
    { id: "brillance", name: "Brillance", price: 220 },
    { id: "protection", name: "Protection", price: 350 },
    { id: "renov", name: "Renov+", price: 600 },
  ],
  rows: [
    { fr: "Prélavage", en: "Pre-wash", inc: [true, true, true, true] },
    { fr: "Entretien de la chaîne", en: "Chain maintenance", inc: [true, true, true, true] },
    { fr: "Lavage profond", en: "Deep wash", inc: [true, true, true, true] },
    { fr: "Traitement des insectes", en: "Bug removal", inc: [true, true, true, true] },
    { fr: "Décontamination", en: "Decontamination", inc: [false, true, true, true] },
    { fr: "Ravivement des plastiques", en: "Plastics revival", inc: [false, true, true, true] },
    { fr: "Antibuée du casque", en: "Helmet anti-fog", inc: [false, true, true, true] },
    { fr: "Ravivement de l'échappement", en: "Exhaust revival", inc: [false, true, true, true] },
    { fr: "Wax", en: "Wax", inc: [false, false, true, true] },
    { fr: "Traitement hydrophobe", en: "Hydrophobic treatment", inc: [false, false, true, true] },
    { fr: "Traitement pour la selle", en: "Seat treatment", inc: [false, false, true, true] },
    { fr: "Céramique", en: "Ceramic coating", inc: [false, false, false, true] },
    { fr: "Céramique sur les jantes", en: "Ceramic on wheels", inc: [false, false, false, true] },
    { fr: "Chargement de la batterie", en: "Battery charging", inc: [false, false, false, true] },
    { fr: "Traitement vapeur", en: "Steam treatment", inc: [false, false, false, true] },
  ],
};
